import React, { useState, useEffect } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./LandingPage.module.scss";
import {useSelector,useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import { Button } from "@onegovbugs/onegov-react-components";
import { IMPORTEXPORT_FORM} from '../../../constants';
import {clearForm, storeCaptcha, setCurrentForm} from '../../../redux/actions';

const LandingPage = props => { 

    //ScrollToTop();

    const dispatch = useDispatch();
    const captcha = useSelector(state => state.captcha);
    
    const startButtonHandler = () => {

        props.history.push('/import-export/introduction')
        
    }

    useEffect(
      () => {
        dispatch(clearForm());
        dispatch(setCurrentForm(IMPORTEXPORT_FORM, "Import or Export Licence"));
  
        const payload = {
          [IMPORTEXPORT_FORM]: false
        };
        dispatch(storeCaptcha(payload));
      },
      [dispatch]
    );


    const renderSection = () => {
        return <div>
            <div className={"row"}>
                <div className={"col-12"}>          
                    <h3>What you need to know</h3>
                    <br/>
                    <p>
                      All Import / Export Licence applications submitted online will now be processed manually by the NPWS Wildlife Team.
                    </p>
                    <br/>
                    <p>
                      The legislative timeframe for processing a duly made application is 28-56 days.
                    </p>
                </div>
            </div>       
            {
                process.env.REACT_APP_CAPTCHA_ENABLED == "true" && (
                    <div className={`row ${styles.buttonCont}`}>
                        <div className={`col-12`}>
                            <ReCAPTCHA
                            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                            onChange={value => {
                                const payload = {
                                [IMPORTEXPORT_FORM]: value !== null
                                };
                                dispatch(storeCaptcha(payload));
                            }}
                            />
                        </div>
                    </div>
                )
            }
        <div className={`row ${styles.buttonCont}`}>
          <div className={`col-6 ${styles.leftCont}`}>
                    {
                        (captcha[IMPORTEXPORT_FORM] ||
                        process.env.REACT_APP_CAPTCHA_ENABLED === "false") &&
                        <Button onClick={() => startButtonHandler()}>
                            Start Application
                        </Button>
                    }
                </div>
            </div> 
        </div>
      }    
  
    return <div className={styles.mainCont}>
      <div className={'row'}>
        <div className={`col-12`}>
          <h1>Apply for Import / Export Licence</h1>
          {renderSection()}
        </div>
      </div>
    </div>
  };
  
  export default withRouter(props => <LandingPage {...props}/>);
  
